import { render, staticRenderFns } from "./ModalVisualizarMidia.vue?vue&type=template&id=28a38673&scoped=true"
import script from "./ModalVisualizarMidia.vue?vue&type=script&lang=js"
export * from "./ModalVisualizarMidia.vue?vue&type=script&lang=js"
import style0 from "./ModalVisualizarMidia.vue?vue&type=style&index=0&id=28a38673&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a38673",
  null
  
)

export default component.exports